import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Pledge from "./Components/Pledge";
import FormPage from "./Components/FormPage";
import ThankYou from "./Components/ThankYou";

function App() {
  const userId = localStorage.getItem("userId");
  const savedName = userId
    ? localStorage.getItem(`userName_${userId}`)
    : localStorage.getItem("userName");

  return (
    <Router>
      <Routes>
        <Route path="/" element={savedName ? <Navigate to="/thankyou" /> : <Pledge />} />
        <Route path="/form" element={<FormPage />} />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
